import Head from 'next/head'
import Link from 'next/link'

const images = [
  'https://images.ctfassets.net/rxdl0mk5gigv/7FRly4hcPuPVLi3oO7fZCP/87bf1f3553f1cc6ecac0cd5ef361b812/_Y3A7432-2.jpg?w=1200',
  'https://images.ctfassets.net/rxdl0mk5gigv/3yVwFJK9Bd5VcEbSaqOiXn/a38139474dd2f16a860d72486815aadb/_Y3A7357.jpg?w=1200',
  'https://images.ctfassets.net/rxdl0mk5gigv/5McPZrbf5qKQxNlnJQO20g/2be80f59342217a705ed7f2d4e5700c2/_Y3A5756.jpg?w=1200',
  'https://images.ctfassets.net/rxdl0mk5gigv/5RAJHpS8iYTfeCrQkJtEAf/c29af054c9daf211a703620ca8aaa972/_Y3A9262.jpg?w=1200',
  'https://images.ctfassets.net/rxdl0mk5gigv/3pkStzcpXXbHBjGDSBSDre/e06469268e79e80b72bb87d08089e9eb/_Y3A8937.jpg?w=1200',
  'https://images.ctfassets.net/rxdl0mk5gigv/47apCCVDZp5Y5PT44qy8pT/1566d55d0bc0b6f7b3a51aecd1d19698/_Y3A9402-2.jpg?w=1200',
  'https://images.ctfassets.net/rxdl0mk5gigv/3Cp9xbDBbdKLPDQG28Iskh/0e7c22a0f6e18ccf70bf8404f8390e52/_Y3A9347.jpg?w=1200',
  'https://images.ctfassets.net/rxdl0mk5gigv/1syyJ1b87hCZ28znmNk0o5/abba4399ed84b5cc0bfebfbf6f9ed9f6/_Y3A8617.jpg?w=1200',
  'https://images.ctfassets.net/rxdl0mk5gigv/6aTGTjt32Jc11cSYkW5Wen/3e5d60ad2254863ee8b24c738d6ce604/_Y3A6772-2.jpg?w=1200',
  'https://images.ctfassets.net/rxdl0mk5gigv/3OygUWn2Bj4FEyaY8KyTJL/0fb1eb80fa328dec18dad2dee0017687/_Y3A6842.jpg?w=1200',
  'https://images.ctfassets.net/rxdl0mk5gigv/fZUXYGY5HnVImAaKYvKnL/2b21d1a17e7ba3d6db2099ff2b75041c/_Y3A6364.jpg?w=1200',
  'https://images.ctfassets.net/rxdl0mk5gigv/5WPq28mxfjJbQGoZKZ6fo1/21b00dd77d13c5362e1997298afe49e9/_Y3A6962.jpg?w=1200',
  'https://images.ctfassets.net/rxdl0mk5gigv/2kcNHu53JnrMv5E9YfXWHn/c291e6b2b8c61b8f4487ddeb93986966/_Y3A6676-2.jpg?w=1200',
  'https://images.ctfassets.net/rxdl0mk5gigv/7xNHpdOD2Jz4Fk8ZN6UAWF/c1570a0ce2513343184e17a24b4e2e25/_Y3A6922.jpg?w=1200',
  'https://images.ctfassets.net/rxdl0mk5gigv/5xB1TAn2cDzbYChCQjkMvH/aeb410ab932b7cf221389f1f856e7f99/_Y3A5942.jpg?w=1200',
  'https://images.ctfassets.net/rxdl0mk5gigv/1Ueu8dyWROaQLfaQIloQBS/8f347050fac96a3c9c451edf6e68d5d7/_Y3A5841.jpg?w=1200',
  'https://images.ctfassets.net/rxdl0mk5gigv/HWNt3nWgxifJpYQsJHWi9/dd3aa44a4171c1a06f320b79cf3b67c8/_Y3A6256.jpg?w=1200',
  'https://images.ctfassets.net/rxdl0mk5gigv/3DwzXOPfISQP8eHqchpP03/b18aebfaf8e2cbbaa4c53c12cc3ee439/_Y3A5977-2.jpg?w=1200',
  'https://images.ctfassets.net/rxdl0mk5gigv/4Q5souX5I0IerxE3x9nURR/148a55aff75cad20ef0a22d9a41e8575/_Y3A6302.jpg?w=1200',
  'https://images.ctfassets.net/rxdl0mk5gigv/5nYs5bgP6Zl3B5lNP8Fd3y/641e25977601c90c59243f663c001d10/_Y3A5856-2.jpg?w=1200',
]

const AnnaCopenhagen = () => {
  return (
    <>
      <Head>
        <title>Anna | Copenhagen | Beyond the Pines</title>
        <meta
          name="description"
          content="A Beyond the Pines Feature | Copenhagen, End of Summer. End of summer always feels like a conversation the earth is having with itself."
        />
        <meta
          name="keywords"
          content="Beyond The Pines, Beyond The Pines Magazine, Copenhagen, Anna, photography, gallery, Beyond The Pines Feature"
        />
      </Head>

      <img src={images[0]} alt="Copenhagen" style={{ width: '100%', height: 'auto' }} />

      <div className="flex flex-col dt:flex-row text-center align-center items-center dt:max-w-full mx-auto px-8 py-4">
        <div className="body-text inline-block dt:w-6/12 mb:mb-height-3">
          <h4 className="mb:mt-8 mb-2 font-soehne-xleight text-md dt-800:text-md text-olive">
            Beyond the Pines presents
          </h4>
          <h1 className="mb-4 font-soehne-leight text-2xl dt-800:text-5xl">
            &quot;Anna | Copenhagen&quot;
          </h1>
          <h4 className="text-md text-light">End of Summer</h4>
        </div>
        <div className="body-image dt:px-3 mb:mb-height-3 dt:w-6/12 mb:w-full inline-block">
          <img src={images[1]} alt="Copenhagen" style={{ width: '100%', height: 'auto' }}></img>
        </div>
      </div>

      <div className="container mx-auto px-8 py-12 dt:max-w-3xl">
        <p className="font-soehne-leight text-lg dt:text-xl leading-relaxed mb-8 text-light">
          End of summer always feels like a conversation the earth is having with itself.
        </p>
        <p className="font-soehne-leight text-lg dt:text-xl leading-relaxed mb-8 text-light">
          Copenhagen woke up quietly that morning. The kind of quiet you don&apos;t interrupt , you enter it gently, like stepping into a cathedral built from fog.
        </p>
        <p className="font-soehne-leight text-lg dt:text-xl leading-relaxed mb-8 text-light">
          The lawn still held the night in its breath. Dew clung to every blade like memory refusing to leave. You could smell the green. Wet soil. Cold air sliding into the lungs and waking parts of the body that sleep all year.
        </p>
      </div>

      <img src={images[2]} alt="Copenhagen" style={{ width: '100%', height: 'auto' }} />

      <div className="container mx-auto px-8 py-12 dt:max-w-3xl">
        <p className="font-soehne-leight text-lg dt:text-xl leading-relaxed mb-8 text-light">
          Anna stood barefoot at the edge of the pond, wrapped in a sweater that belonged to another season. A girl from Hawaii learning the language of northern cold.
        </p>
        <p className="font-soehne-leight text-xl dt:text-2xl leading-relaxed mb-6 text-center italic">
          You could see it in the way her shoulders held the air , not resisting it, just negotiating with it.
        </p>
      </div>

      <div className="grid grid-cols-1 dt:grid-cols-2 gap-4 px-8 py-8">
        <img src={images[3]} alt="Copenhagen" style={{ width: '100%', height: 'auto' }}></img>
        <img src={images[4]} alt="Copenhagen" style={{ width: '100%', height: 'auto' }}></img>
      </div>

      <div className="container mx-auto px-8 py-12 dt:max-w-3xl">
        <p className="font-soehne-leight text-lg dt:text-xl leading-relaxed mb-8 text-light">
          The house behind her was too beautiful to feel owned , it felt borrowed, like we were temporary guests inside a painting. Water barely moved. Even the birds seemed to agree to keep their voices low.
        </p>
        <p className="font-soehne-leight text-lg dt:text-xl leading-relaxed mb-6 text-light">
          Nothing wanted to break the surface of the morning.
        </p>
      </div>

      <img src={images[5]} alt="Copenhagen" style={{ width: '100%', height: 'auto' }} />

      <div className="container mx-auto px-8 py-12 dt:max-w-3xl">
        <p className="font-soehne-leight text-lg dt:text-xl leading-relaxed mb-8 text-light text-center">
          There was something oceanic about her stillness.
        </p>
        <div className="text-center py-6">
          <p className="font-soehne-leight text-xl dt:text-2xl leading-relaxed mb-4 italic">
            As if a warmer coastline followed her invisibly,
          </p>
          <p className="font-soehne-leight text-xl dt:text-2xl leading-relaxed italic">
            stitched into her posture.
          </p>
        </div>
      </div>

      <div className="grid dt:grid-cols-3 grid-cols-1 gap-4 px-8 py-8">
        <img src={images[6]} alt="Copenhagen" style={{ width: '100%', height: 'auto' }}></img>
        <img src={images[7]} alt="Copenhagen" style={{ width: '100%', height: 'auto' }}></img>
        <img src={images[8]} alt="Copenhagen" style={{ width: '100%', height: 'auto' }}></img>
      </div>

      <div className="container mx-auto px-8 py-12 dt:max-w-3xl">
        <p className="font-soehne-leight text-lg dt:text-xl leading-relaxed mb-6 text-light">
          The pond mirrored her the way memory mirrors home , not exact, but close enough to ache.
        </p>
        <p className="font-soehne-leight text-lg dt:text-xl leading-relaxed mb-6 text-light">
          Watching her there, you could feel time doing what it always does , not rushing, not stopping , just passing through us the way wind passes through tall grass.
        </p>
      </div>

      <img src={images[9]} alt="Copenhagen" style={{ width: '100%', height: 'auto' }} />

      <div className="container mx-auto px-8 py-12 dt:max-w-3xl">
        <p className="font-soehne-leight text-lg dt:text-xl leading-relaxed mb-8 text-light">
          We pretend we&apos;re separate from it, but mornings like this expose the illusion.
        </p>
        <p className="font-soehne-leight text-xl dt:text-2xl leading-relaxed mb-6 text-center italic">
          We are weather. We are seasons wearing human faces.
        </p>
      </div>

      <div className="grid dt:grid-cols-2 grid-cols-1 gap-4 px-8 py-8">
        <img src={images[10]} alt="Copenhagen" style={{ width: '100%', height: 'auto' }}></img>
        <img src={images[11]} alt="Copenhagen" style={{ width: '100%', height: 'auto' }}></img>
      </div>

      <div className="container mx-auto px-8 py-12 dt:max-w-3xl">
        <p className="font-soehne-leight text-lg dt:text-xl leading-relaxed mb-6 text-light">
          The camera clicked softly, almost apologetically. Not to capture her , that would be impossible , but to admit we were there.
        </p>
        <p className="font-soehne-leight text-lg dt:text-xl leading-relaxed mb-6 text-light text-center italic">
          To say: this happened.
        </p>
      </div>

      <div
        style={{
          backgroundImage:
            "url('https://www.toptal.com/designers/subtlepatterns/uploads/ricepaper2.png')"
        }}
      >
        <h1 className="mb-0 p-8 text-olive text-center dt-800 font-soehne-leight text-2xl dt-800:text-4xl italic">
          &quot;We are weather. We are seasons wearing human faces.&quot;
        </h1>
      </div>

      <div className="grid dt:grid-cols-3 grid-cols-1 gap-4 px-8 py-8">
        <img src={images[12]} alt="Copenhagen" style={{ width: '100%', height: 'auto' }}></img>
        <img src={images[13]} alt="Copenhagen" style={{ width: '100%', height: 'auto' }}></img>
        <img src={images[14]} alt="Copenhagen" style={{ width: '100%', height: 'auto' }}></img>
      </div>

      <div className="container mx-auto px-8 py-12 dt:max-w-3xl">
        <p className="font-soehne-leight text-lg dt:text-xl leading-relaxed mb-8 text-light">
          A woman carrying an island inside her breath. Fog leaving her lips. A house floating in still water. Summer exhaling its final warmth into autumn&apos;s hands.
        </p>
      </div>

      <div className="grid dt:grid-cols-2 grid-cols-1 gap-4 px-8 py-8">
        <img src={images[15]} alt="Copenhagen" style={{ width: '100%', height: 'auto' }}></img>
        <img src={images[16]} alt="Copenhagen" style={{ width: '100%', height: 'auto' }}></img>
      </div>

      <div className="container mx-auto px-8 py-12 dt:max-w-3xl">
        <p className="font-soehne-leight text-lg dt:text-xl leading-relaxed mb-8 text-light">
          The lawn smelled alive.
        </p>
        <p className="font-soehne-leight text-xl dt:text-2xl leading-relaxed text-center italic">
          And for a moment, so did everything else.
        </p>
      </div>

      <div className="grid dt:grid-cols-2 grid-cols-1 gap-4 px-8 py-8">
        <img src={images[17]} alt="Copenhagen" style={{ width: '100%', height: 'auto' }}></img>
        <img src={images[18]} alt="Copenhagen" style={{ width: '100%', height: 'auto' }}></img>
      </div>

      <img src={images[19]} alt="Copenhagen" style={{ width: '100%', height: 'auto' }} />

      <div className="container mx-auto px-8 py-8">
        <p className="font-soehne-leight text-base leading-relaxed mb-6 text-center mt-8">
        </p>
      </div>

      <div className="container mx-auto px-8 py-12 text-center">
        <div className="flex flex-col md:flex-row gap-6 justify-center items-center">
          <Link href="/muses">
            <a className="px-8 py-4 border-2 border-black text-black font-soehne-leight text-lg hover:bg-black hover:text-white transition-colors duration-300">
              View More Content
            </a>
          </Link>
          <Link href="/subscribe">
            <a className="px-8 py-4 bg-black text-white font-soehne-leight text-lg hover:bg-olive transition-colors duration-300">
              Subscribe for More
            </a>
          </Link>
        </div>
      </div>
    </>
  )
}

export async function getStaticProps() {
  return {
    props: {
      title: 'Anna | Copenhagen | Beyond the Pines',
      description: 'A Beyond the Pines Feature | Copenhagen, End of Summer. End of summer always feels like a conversation the earth is having with itself.',
      image: 'https://images.ctfassets.net/rxdl0mk5gigv/7FRly4hcPuPVLi3oO7fZCP/87bf1f3553f1cc6ecac0cd5ef361b812/_Y3A7432-2.jpg?w=1200',
    },
  }
}

export default AnnaCopenhagen
